import { useMemo } from "react";

import type { ExistingDummyRoomDefault_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import { useInitProductDummyRoomFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-mode/server-model-to-input-mode";
import { useDummyRoomEditMutation } from "../../../repository/existing";

import type { ProductDummyExistingRoomFormModelContextType } from "../../../../ui/existing/context/context";

type Props = {
	serverModel: ExistingDummyRoomDefault_EditPageQuery;
};

export const useInitialized = ({ serverModel }: Props): ProductDummyExistingRoomFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = {
		connection: {
			planNameAndIDOptions: [
				...serverModel.planList.plans.map(
					(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
				),
				...serverModel.planList.secrets.map(
					(plan) => ({ id: plan.id, label: plan.name, value: plan.planID }) satisfies FormOptionType,
				),
			],
		},
	};

	const { onSetViewModel, viewModel, resetViewModel } = useInitProductDummyRoomFormModelContext({
		inputModel,
		queryData,
	});

	const { onUpdate } = useDummyRoomEditMutation({ resetForm: resetViewModel });

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
